<script setup>
import { RouterView } from 'vue-router'
import { onMounted, watch } from 'vue'
import { useUserStore } from '@/stores/user.js'
import { useAuth0 } from '@auth0/auth0-vue'

const {isAuthenticated} = useAuth0()
const userStore = useUserStore()

watch(isAuthenticated, (newValue) => {
  if(newValue){
    userStore.retrieveProfile()
  }
})

onMounted(() => {
  const darkMode = localStorage.getItem('darkMode')
  const prefersDarkScheme = window.matchMedia('(prefers-color-scheme: dark)')

  const applyDarkMode = (isDark) => {
    if (isDark) {
      document.documentElement.classList.add('dark')
      localStorage.setItem('darkMode', 'true')
    } else {
      document.documentElement.classList.remove('dark')
      localStorage.setItem('darkMode', 'false')
    }
  }

  applyDarkMode(darkMode === 'true' || (!darkMode && prefersDarkScheme.matches))

  prefersDarkScheme.addEventListener('change', (e) => {
    if (!darkMode) { // Only apply system preference if no user preference is set
      applyDarkMode(e.matches)
    }
  })
})

</script>

<template>
  <div class="flex flex-col h-screen w-full backdrop-blur-3xl">
    <RouterView class="flex flex-col w-full flex-grow min-h-0" />
    <div id="modal-root" class="fixed top-0 left-0 w-full h-full z-50 pointer-events-none"></div>
  </div>
</template>

<style scoped>
.background {
  /* background: linear-gradient(57deg,
  hsla(296, 55%, 51%, 0.3) 0%,
  hsla(17, 61%, 50%, 0.3) 16%,
  hsla(320, 36%, 50%, 0) 25%) */
  background-color: #FAF3DD;
}
</style>
